/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AlgoAction } from './AlgoAction';
import {
    AlgoActionFromJSON,
    AlgoActionFromJSONTyped,
    AlgoActionToJSON,
} from './AlgoAction';
import type { CustomAssetLifecycleColumn } from './CustomAssetLifecycleColumn';
import {
    CustomAssetLifecycleColumnFromJSON,
    CustomAssetLifecycleColumnFromJSONTyped,
    CustomAssetLifecycleColumnToJSON,
} from './CustomAssetLifecycleColumn';

/**
 * 
 * @export
 * @interface CustomAssetLifecycle
 */
export interface CustomAssetLifecycle {
    /**
     * 
     * @type {number}
     * @memberof CustomAssetLifecycle
     */
    optimizationId: number;
    /**
     * 
     * @type {string}
     * @memberof CustomAssetLifecycle
     */
    pId: string;
    /**
     * 
     * @type {AlgoAction}
     * @memberof CustomAssetLifecycle
     */
    algoAction: AlgoAction;
    /**
     * 
     * @type {Array<CustomAssetLifecycleColumn>}
     * @memberof CustomAssetLifecycle
     */
    columns: Array<CustomAssetLifecycleColumn>;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof CustomAssetLifecycle
     */
    rows: Array<{ [key: string]: any; }>;
}



/**
 * Check if a given object implements the CustomAssetLifecycle interface.
 */
export function instanceOfCustomAssetLifecycle(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "optimizationId" in value;
    isInstance = isInstance && "pId" in value;
    isInstance = isInstance && "algoAction" in value;
    isInstance = isInstance && "columns" in value;
    isInstance = isInstance && "rows" in value;

    return isInstance;
}

export function CustomAssetLifecycleFromJSON(json: any): CustomAssetLifecycle {
    return CustomAssetLifecycleFromJSONTyped(json, false);
}

export function CustomAssetLifecycleFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomAssetLifecycle {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'optimizationId': json['optimization_id'],
        'pId': json['p_id'],
        'algoAction': AlgoActionFromJSON(json['algo_action']),
        'columns': ((json['columns'] as Array<any>).map(CustomAssetLifecycleColumnFromJSON)),
        'rows': json['rows'],
    };
}

export function CustomAssetLifecycleToJSON(value?: CustomAssetLifecycle | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'optimization_id': value.optimizationId,
        'p_id': value.pId,
        'algo_action': AlgoActionToJSON(value.algoAction),
        'columns': ((value.columns as Array<any>).map(CustomAssetLifecycleColumnToJSON)),
        'rows': value.rows,
    };
}

